var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"bg-white border-white"},[(!_vm.dataReady)?_c('loading-spinner',{attrs:{"color":"#000","waitingText":"Loading ..."}}):_c('booking-table',{attrs:{"bookings":_vm.bookings},on:{"find":_vm.find}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }